import React, { useState, useRef, useEffect } from 'react';

const CustomAdvanceDropdown = ({ label, options, selectedState, setSelectedState, disabled, required = false, optionType = "single" }) => {
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const dropdownRef = useRef(null);

    const handleSelection = (option) => {
        setSelectedState(option);
        setIsDropdownOpen(false);
    };

    const handleClickOutside = (event) => {
        if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
            setIsDropdownOpen(false);
        }
    };

    useEffect(() => {
        document.addEventListener('click', handleClickOutside);
        return () => {
            document.removeEventListener('click', handleClickOutside);
        };
    }, []);

    return (
        <div className={`boxCard ${disabled ? 'disabled' : ''}`} ref={dropdownRef}>
            {
                label !="" &&
            
            <label className="commonLabelSecond" htmlFor="">
                {label ?? 'Select'}

                {
                    required == true &&
                    <font className="req-sym">*</font>
                }
            </label>
            }
            <div className="bokunDropBox discriplangDown">
                <a
                    className={`main mainDisk ${disabled ? 'disabled' : ''}`}
                    href="javascript:void(0)"
                    onClick={() => !disabled && setIsDropdownOpen(!isDropdownOpen)}
                >
                    <span>{optionType == 'single' ? selectedState : selectedState?.name}</span>
                    <div className="iconDown">
                        <i className="fa-solid fa-chevron-down"></i>
                    </div>
                </a>
                <ul className="DropBox" style={{ display: isDropdownOpen && !disabled ? 'block' : 'none' }}>
                    {options.map((option, index) => (
                        <li key={index}>
                            <a
                                href="javascript:void(0)"
                                onClick={() => handleSelection(option)}
                            >
                                {optionType == 'single' ? option : option?.name}
                            </a>
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    );
};

export default CustomAdvanceDropdown;
